// extracted by mini-css-extract-plugin
export default {"button":"Wl-z","reviewSort":"Xl-z"};